// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"30300b74","50":"74d368dd","171":"5295c9dd","172":"63f10d14","321":"7c0b2553","620":"eca060ef","621":"3b450715","745":"4a3a70e8","992":"780bec24"}[chunkId] + ".chunk.js";
};